import * as React from 'react';
import { Box, Typography, Card, Button, SvgIcon, MuiBox, color } from '@kis-technologies/kis-ui';
import { useSelector } from 'react-redux';
import { useActions } from 'hooks/useActions';
import {
  selectors as hardwareSelectors,
  actions as hardwareActions,
  PaymentDevice as PaymentDeviceProps
} from 'services/hardware';
import { ERROR, OPERATIONAL, NOT_CONNECTED, UNKNOWN } from 'constants/hardware';
import { ActionOverlay } from 'components/ActionOverlay';
import { useStyles } from '../styled';

export const PaymentDevice = () => {
  // Actions and Selectors
  const { status } = useSelector(hardwareSelectors.selectPaymentDevice) as PaymentDeviceProps;
  const { paymentDevicePing } = useActions({
    paymentDevicePing: hardwareActions.paymentPing
  });

  React.useEffect(() => {
    if (status.code === UNKNOWN) paymentDevicePing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Show Troubleshoot Overlay
  const [showTroubleshoot, setShowTroubleshoot] = React.useState(false);

  const classes = useStyles();

  const onTroubleshootConfirm = () => {
    paymentDevicePing(true);
    setShowTroubleshoot(false);
  };

  // **************
  // **  RENDER  **
  // **************

  const renderMessage = () => {
    if (status.code === OPERATIONAL) return 'Your payment device is operational and no additional action is required.';
    if (status.code === ERROR || status.code === NOT_CONNECTED) {
      return 'Your payment device is experiencing some issues.';
    }
    return null;
  };

  const renderAction = () => {
    if (status.code === OPERATIONAL) return <SvgIcon name="success_circle" size={46} color={color.GREEN} />;
    if (status.code === ERROR || status.code === NOT_CONNECTED) {
      return <SvgIcon name="error_circle" size={46} color={color.RED} />;
    }
    return null;
  };

  return (
    <>
      <MuiBox className={classes.systemCheckHardwareDevices} margin="0 3 0 0">
        <Card fullHeight hasBorderRadius raised>
          <Card.Title
            gutter={5}
            title={
              <Typography fontSize={24} fontWeight={900}>
                Payment Device
              </Typography>
            }
            action={renderAction()}
          />
          <Card.Content gutter={5}>
            <Box flexOverride="1">
              <Typography fontSize={15}>{renderMessage()}</Typography>
            </Box>
            {(status.code === ERROR || status.code === NOT_CONNECTED) && (
              <Button customSize="medium" appearance="error" fullWidth onClick={() => setShowTroubleshoot(true)}>
                Resolve
              </Button>
            )}
          </Card.Content>
        </Card>
      </MuiBox>
      {showTroubleshoot && (
        <ActionOverlay
          title="The system is experiencing an issue."
          description="Please contact your admin at this time for support. It is recommended you take the kiosk inactive while this issue is resolved."
          cancelText="Close"
          confirmText="Retest"
          onConfirm={onTroubleshootConfirm}
          onCancel={() => setShowTroubleshoot(false)}
        />
      )}
    </>
  );
};
